import { toast } from "react-toastify";
import { useLoaderData } from "react-router-dom";
import { createContext, useContext } from "react";
import { customFetch } from "../utils/custom-fetch.js";
import {
  OfficeBuilding,
  OfficesContainer,
  OfficeBuildingSearchContainer,
  OfficeBuildingPaginationContainer,
} from "../components/Office/";
import { useNavigate } from "react-router-dom";

export const loader = async ({ request }) => {
  const params = Object.fromEntries(
    new URL(request.url).searchParams.entries()
  );

  try {
    const [{ data: officesData }, { data: companies }, { data: cities }] =
      await Promise.all([
        customFetch.get("/floors-navigation", { params }), // רשימת משרדים
        customFetch.get("/buildings/maintenance-companies"),
        customFetch.get("/floors-navigation/cities-streets-buildings"),
      ]);
      
    const maintenanceCompanies = [
      { _id: "הכל", name: "הכל" },
      ...companies.map((c) => ({
        _id: c.value,
        name: c.lastName ? `${c.name} ${c.lastName}` : c.name,
      })),
    ];

    return { data: officesData, cities };
  } catch (err) {
    toast.error(err?.response?.data?.msg || "שגיאה בטעינת נתונים");
    throw err;
  }
};

const AllOfficesContext = createContext();
export const useAllOfficesContext = () => useContext(AllOfficesContext);

const AllOfficeBuildings = () => {
  const { data,maintenanceCompanies, cities } = useLoaderData();
  
  const navigate = useNavigate();

  return (
    <AllOfficesContext.Provider value={{ data,maintenanceCompanies, cities }}>
      <button
        type="button"
        style={{ marginBottom: "1rem" }}
        className="btn btn-primary"
        onClick={() => navigate("/dashboard/add-floor-navigation")}
      >
        צור בניין משרדים חדש
      </button>
      <OfficeBuildingSearchContainer />
      <OfficesContainer />
    </AllOfficesContext.Provider>
  );
};

export default AllOfficeBuildings;
